import React from 'react'
import { Box, Layers2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { VI_MESSAGES } from '@/constants/vietnamese'
import { useUIStore, type ViewMode } from '@/stores/uiStore'
// import MapService from '@/services/arcgis/MapServiceFacade'
// import { useToast } from '@/hooks/use-toast';

interface ViewModeToggleProps {
  className?: string
}

/**
 * Component chuyển đổi giữa chế độ xem 2D và 3D
 */
export const ViewModeToggle: React.FC<ViewModeToggleProps> = ({ className = '' }) => {
  const { viewMode, setViewMode, setViewSwitching, webGL2Supported } = useUIStore()
  // const { toast } = useToast();

  const handleToggleView = async () => {
    try {
      if (!webGL2Supported && viewMode === '2D') {
        // toast({
        //   title: VI_MESSAGES.MAP.VIEW_MODE.NOT_SUPPORTED,
        //   variant: 'destructive',
        // });
        console.log(VI_MESSAGES.MAP.VIEW_MODE.NOT_SUPPORTED)
        return
      }

      setViewSwitching(true)
      const newMode: ViewMode = viewMode === '2D' ? '3D' : '2D'

      // Switch view in MapService
      // await MapService.switchView(newMode);

      // Update UI state
      setViewMode(newMode)

      // toast({
      //   title: newMode === '3D'
      //     ? VI_MESSAGES.MAP.VIEW_MODE.MODE_3D
      //     : VI_MESSAGES.MAP.VIEW_MODE.MODE_2D,
      //   description: 'Chế độ xem đã được chuyển đổi',
      // });
      console.log(
        newMode === '3D' ? VI_MESSAGES.MAP.VIEW_MODE.MODE_3D : VI_MESSAGES.MAP.VIEW_MODE.MODE_2D
      )
    } catch (error) {
      console.error('Error switching view mode:', error)
      // toast({
      //   title: 'Lỗi',
      //   description: 'Không thể chuyển đổi chế độ xem',
      //   variant: 'destructive',
      // });
    } finally {
      setViewSwitching(false)
    }
  }

  // Don't show the toggle if 3D is not enabled
  // if (!MapService.is3DSupported()) {
  //   return null;
  // }

  const Icon = viewMode === '2D' ? Box : Layers2
  const tooltipText =
    viewMode === '2D' ? VI_MESSAGES.MAP.VIEW_MODE.TOGGLE_3D : VI_MESSAGES.MAP.VIEW_MODE.TOGGLE_2D

  return (
    <TooltipProvider>
      <div className={className}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              size="icon"
              variant="secondary"
              className="h-8 w-8 bg-white/90 shadow-md backdrop-blur-sm hover:bg-white/95 hover:shadow-lg"
              onClick={handleToggleView}
              disabled={!webGL2Supported && viewMode === '2D'}
            >
              <Icon className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="left">
            <p>{tooltipText}</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  )
}
